// extracted by mini-css-extract-plugin
module.exports = {"pt-policy-detail-content":"pt-policy-detail-content-06c45b35cd3c71fab43f55fc41dfd161","pt-policy-detail-table":"pt-policy-detail-table-3641247bbbc7b9d6f5656a1b4754b701"};